import { HStack } from "native-base";

export const ButtonBarReportWrapper = ({ children }) => (
  <HStack space={3} justifyContent="center">
    {children}
  </HStack>
);
